import {ScoresListHeaderModuleTerms} from "./scores-list-header-module.terms";
import {BaseConfig} from "../../infrastructure/config/base-config";

export class ScoresListHeaderModuleConfig extends BaseConfig {
  nextDaysAmountToBeLink: Number;
  prevDaysAmountToBeLink: Number;

  static injectables = [ScoresListHeaderModuleTerms];

  constructor(terms: ScoresListHeaderModuleTerms){
    super('scoresListWidget', null, terms);

    this.prevDaysAmountToBeLink = -7;
    this.nextDaysAmountToBeLink = 30;
  }
}
